const state = {
  termValue: 0,
};

const mutations = {
  CHANGE_TERM_VALUE(state, payload) {
    state.termValue = payload;
  },
};

export default {
  state,
  mutations,
};



// WEBPACK FOOTER //
// ./resources/js/store/modules/term.js